import { IQuickTimeSlot, IRange } from '@jooxter/utils';

export enum JxtSmartSlotContainerGapEnum {
  SMALL = 'SMALL',
  REGULAR = 'REGULAR',
}

export interface IJxtSmartSlotContainer {
  range: IRange;
  slots: IQuickTimeSlot[];
  loading?: boolean;
  gap?: JxtSmartSlotContainerGapEnum;
  onSlotSelection: (slot: IQuickTimeSlot) => void;
  autoSelectFirstSlot?: boolean;
}
